export default "/images/PodcastGrolmanCircularTable Talks_640-1024.jpg?68c7d93e5d59ec9ed07da61c180a29c7";